import { ethers } from 'ethers'

export const getProvider = async (provider) => {
  return new ethers.providers.Web3Provider(provider)
}

export const requestAccounts = async (provider) => {
  return await provider.send('eth_requestAccounts', [])
}

export const signMessage = async (baseProvider, message) => {
  const provider = await getProvider(baseProvider)
  const signer = provider.getSigner()
  const signature = await signer.signMessage(message)
  return {
    signature,
    digest: message,
  }
}
